import request from '@/utils/request'

// 题目管理
export function getQuestions(params) {
  return request({
    url: '/questions',
    method: 'get',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    },
    params
  })
}

export function createQuestion(data) {
  return request({
    url: '/questions',
    method: 'post',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    },
    data
  })
}

export function updateQuestion(id, data) {
  return request({
    url: `/questions/${id}`,
    method: 'patch',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    },
    data
  })
}

export function deleteQuestion(id) {
  return request({
    url: `/questions/${id}`,
    method: 'delete',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  })
}

// 获取相似题目
export function fetchSimilarQuestions(questionId, { limit = 5, minSimilarity = 0.3 } = {}) {
  return request({
    url: `/questions/${questionId}/similar`,
    method: 'get',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    },
    params: { limit, minSimilarity }
  })
}

export function generateSimilarQuestions(questionId, { count = 3 } = {}) {
  return request({
    url: `/questions/${questionId}/similar/generate`,
    method: 'post',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    },
    data: { count }
  })
}

export function generateAiSimilarQuestions(questionId, { count = 3, useTemplate = true } = {}) {
  return request({
    url: `/questions/${questionId}/similar/generate-ai`,
    method: 'post',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    },
    data: { count, useTemplate }
  })
}

// 抽取/匹配解法模板（模板化相似题第一步）
export function extractQuestionTemplate(questionId) {
  return request({
    url: `/questions/${questionId}/similar/extract-template`,
    method: 'post',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  })
}

// 确认并保存解法模板
export function confirmQuestionTemplate({ sourceQuestionId, template }) {
  return request({
    url: `/questions/templates/confirm`,
    method: 'post',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    },
    data: { sourceQuestionId, template }
  })
}

// 分类管理
export const getCategories = () => {
  return request({
    url: '/categories',
    method: 'get'
  })
}

export const createCategory = (data) => {
  return request({
    url: '/categories',
    method: 'post',
    data
  })
}

export const updateCategory = (id, data) => {
  return request({
    url: `/categories/${id}`,
    method: 'put',
    data
  })
}

export const deleteCategory = (id) => {
  return request({
    url: `/categories/${id}`,
    method: 'delete'
  })
}

// 用户管理
export function getUsers() {
  return request({
    url: '/users',
    method: 'get',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  })
}

export function updateUserRole(id, data) {
  return request({
    url: `/users/${id}/role`,
    method: 'patch',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    },
    data
  })
}

export function deleteUser(id) {
  return request({
    url: `/users/${id}`,
    method: 'delete',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  })
}

// 上传图片
export function uploadImage(file) {
  const formData = new FormData()
  formData.append('image', file)
  
  return request({
    url: '/upload/image',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `Bearer ${localStorage.getItem('token')}`
    },
    data: formData
  })
} 
